<black-ui-modal>
  <ng-container
    [ngTemplateOutlet]="this.trigger?.templateRef || default_trigger"
    *blackModalTrigger="let toggle = toggle"
    [ngTemplateOutletContext]="{ toggle}"
  ></ng-container>
  <div
    *blackModalContent="let close = close"
    class="reveal-modal"
    (click)="close()"
    >
    <div
      class="reveal-modal-body bg-base-100 text-base-content border border-base-300 rounded-2xl shadow-2xl max-w-md w-full p-4"
      (click)="$event.stopPropagation()"
      >
      <div class="daisy-card w-full">
        <div class="daisy-card-body">
          <h2 class="daisy-card-title">{{ title }}</h2>
          <p>{{ bodyText }}</p>
          <div class="daisy-card-actions justify-end">
            @if (showCancel) {
              <button class="daisy-btn" (click)="close()">
                Cancel
              </button>
            }
            <button
              [class]="getConfirmButtonClass(confirmBtnLevel)"
              (click)="onConfirm()"
              >
              {{ confirmButtonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</black-ui-modal>

<ng-template #default_trigger
  ><button class="daisy-btn">{{ triggerButtonText }}</button></ng-template
  >
